import Vue from 'vue'
import Vuex from 'vuex'
import { auth, state } from './auth'
import { things } from './things'
import { mapState } from './map'
import { reports } from './reports'
import { ui } from './ui'

Vue.use(Vuex)
Vue.config.devtools = process.env.NODE_ENV === 'development'

export default new Vuex.Store({
  state: {
    user: {
      id: '',
      first_name: '',
      last_name: '',
      username: '',
      isAdmin: false,
      hasScheduledReportRole: false,
      photo: ''
    },
    searchInput: '',
    searchMatch: [],
    matchPosition: 1,
    showResult: false,
    countryId: localStorage.getItem('country_id') ?? '',
    disconnectDialogValue: false
  },
  actions: {
    setSearch({ commit }, payload) {
      commit('setSearch', payload)
    },
    setSearchMatch({ commit }, payload) {
      commit('setSearchMatch', payload)
    },
    setMatchPosition({ commit }, matchPosition) {
      commit('setMatchPosition', matchPosition)
    }
  },
  mutations: {
    clearResult(state) {
      state.showResult = false
    },
    displayResult(state) {
      state.showResult = !state.showResult
    },
    setSearch(state, payload) {
      state.searchInput = payload
    },
    setSearchMatch(state, payload) {
      state.searchMatch = payload
    },
    setMatchPosition(state, matchPosition) {
      state.matchPosition = matchPosition
    },
    setUser(state, user) {
      state.user = user
    },
    setDisconnectDialogValue(state, payload) {
      state.disconnectDialogValue = payload
    },
  },
  getters: {
    userId: state => state.user.id,
    isAdmin: state => state.user.isAdmin,
    getCountryId: state => state.countryId,
    hasScheduledReportRole: state => state.user.hasScheduledReportRole,
    setSearch(state, payload) {
      state.searchInput = payload
    },
    setSearchMatch(state, payload) {
      state.searchMatch = payload
    },
    setMatchPosition(state, matchPosition) {
      state.matchPosition = matchPosition
    },
    getSearchInput: state => {
      return state.searchInput
    },
    getSearchMatch: state => {
      return state.searchMatch
    },
    getMatchPosition: state => {
      return state.matchPosition
    }
  },
  modules: {
    auth,
    things,
    reports,
    mapState,
    ui
  }
})
